import bootstrap from 'bootstrap';
import Readmore from './classes/readmore';
import SaitApp from './classes/sait-app';

const LazyLoad = require('vanilla-lazyload');

// global window defines
declare global {
    interface Window { 
        lazyload: any;
        bootstrap: any;
        saitApp: SaitApp;
     }
}

const globalInit = function () {
    // global js functions
    let lazyload = new LazyLoad();
    lazyload.update();
    window.lazyload = lazyload;
    window.bootstrap = bootstrap;

    // cheeky hack to patch underlines for new ion-icons font
    const ioniconsOnPage = document.querySelectorAll('a ion-icon');
    if (ioniconsOnPage && ioniconsOnPage.length > 0) {
        ioniconsOnPage.forEach(function(icon) { icon.parentElement.classList.add("text-decoration-none") });
    }

    // start search buttons and input fields
    const navBarSearchBtn = document.getElementById("mainSearchToggle") as HTMLButtonElement;
    const navBarSearchBtnScrolled = document.getElementById("mainSearchToggleScrolled") as HTMLButtonElement;
    const homepageBtn = document.getElementById("mainsite-search-homepage-btn") as HTMLButtonElement;
    const homepageInput = document.getElementById("mainsite-search-homepage-input") as HTMLInputElement;
    
    navBarSearchBtn?.addEventListener("click", () => {
        window.location.href = "/search";
    });

    navBarSearchBtnScrolled?.addEventListener("click", () => {
        window.location.href = "/search";
    });
    
    homepageBtn?.addEventListener("click", () => {
        const query = homepageInput?.value ? `?q=${homepageInput.value}` : '';
        window.location.href = `/search${query}`;
    });
    
    homepageInput?.addEventListener("keyup", event => {
        if (event.key === 'Enter') {
            window.location.href = `/search?q=${homepageInput.value}`;
        }
    });
    // end search buttons and input fields

    window.saitApp = new SaitApp();

    // Fix for modals backdrop overtop of modal
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.modal').forEach(modal => document.body.appendChild(modal));
    });

    // TODO: support more than one readmore per page
    let readMore = new Readmore('readmore-container');
}
globalInit();